import React 		from 'react';
import ReactDOM 	from 'react-dom';
import BLComponent	from '../core/_BLComponent.jsx';

export default class Brand extends BLComponent {
	constructor(props, context) {
		super(props, context);

		this.state = {
			storeName: blapp.session.getMe() && blapp.session.getMe().store ? blapp.session.getMe().store.skUsernameOwner : '%STORE_NAME%',
			copied: ''
		};
	}

	render() {
		return (
			<main className="main main--white">
				<article className="main__content l-pad-top--xxl">
					{this.renderHeader()}
					{this.renderLogo()}
					{this.renderLogoWithTagline()}
					{this.renderGlyph()}
					{this.renderDownloadAllLogos()}
					{this.renderSpacing()}
					{this.renderTreatments()}
					{this.renderTextAlts()}
					{this.renderStoreBadges()}
				</article>
			</main>
		);
	}

	renderHeader() {
		return (
			<header className="l-border--bottom l-border--x-thick l-pad-bottom--xxl">
				<h1 className="text--xxl-title text--bold text--tight">Brand assets</h1>
				<h2 className="text--title">Download brand assets and view guidelines on how to use them</h2>
				<p className="text-color--lightGrey">Last updated on September 12, 2019 11:50 EDT</p>
				<div className="l-margin-top--xl brand__section-col-container ">
					<a href={"//" + blapp.config.getHost( "static2" ) + "/img/brand/BrickLink_logo-files.zip"} target="_blank" className="btn btn--cta text--white l-flex l-center text--left brand__section-col brand__section-col--auto l-flex-align-start">
						<i className="fas fa-download text--title l-margin-right"/>
						<div>
							<strong className="l-block">Download all artwork</strong>
							<small className="text--opaque">ZIP file, 195kb</small>
						</div>
					</a>
					<p className="text--small text-color--lightGrey brand__download-notice brand__section-col">
						By downloading our artwork, you agree not to edit, change or manipulate them. Artwork formats include png and svg.
					</p>
				</div>
			</header>
		);
	}

	renderLogo() {
		return (
			<section className="brand__section">
				<h3 className="text--title text--bold l-margin-bottom--xl">Logo</h3>
				<div className="brand__section-col-container">
					<div className="brand__section-col">
						<div className="brand__logo-container">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/logo-main@2x.png"} style={{maxWidth: '261px'}}/>
						</div>
						<p className="l-margin-top text-color--lightGrey">The BrickLink logo should be used in this form whenever possible and works best in light themes.</p>
					</div>
					<div className="brand__section-col">
						<div className="brand__logo-container brand__logo-container--tight brand__logo-container--dark">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/logo-inverted@2x.png"} style={{maxWidth: '269px'}}/>
						</div>
						<p className="l-margin-top text-color--lightGrey">The inverted BrickLink logo with the white wordmark will work best in dark themes.</p>
					</div>
				</div>
				<div className="l-margin-top text-color--lightGrey">
					<a href={"//" + blapp.config.getHost( "static2" ) + "/img/brand/BrickLink-logo.zip"} target="_blank"><i className="far fa-file-download l-margin-right--sm"/>Download main logos</a> / ZIP file, 50kb
				</div>
			</section>
		);
	}

	renderLogoWithTagline() {
		return (
			<section className="brand__section">
				<h3 className="text--title text--bold l-margin-bottom--xl">Logo with tagline</h3>
				<div className="brand__section-col-container">
					<div className="brand__section-col">
						<div className="brand__logo-container">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/logo-main_tagline@2x.png"} style={{maxWidth: '263px'}}/>
						</div>
						<p className="l-margin-top text-color--lightGrey">Use the BrickLink logo with the tagline to provide context about BrickLink.</p>
					</div>
					<div className="brand__section-col">
						<div className="brand__logo-container brand__logo-container--dark brand__logo-container--tight">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/logo-inverted_tagline@2x.png"} style={{maxWidth: '269px'}}/>
						</div>
						<p className="l-margin-top text-color--lightGrey">For dark themes, use the inverted BrickLink logo with the tagline to provide context about BrickLink.</p>
					</div>
				</div>
				<div className="l-margin-top text-color--lightGrey">
					<a href={"//" + blapp.config.getHost( "static2" ) + "/img/brand/BrickLink-logo-tagline.zip"} target="_blank"><i className="far fa-file-download l-margin-right--sm"/>Download main logos with tagline</a> / ZIP file, 76kb
				</div>
			</section>
		);
	}

	renderGlyph() {
		return (
			<section className="brand__section">
				<h3 className="text--title text--bold l-margin-bottom--xl">Glyph</h3>
				<div className="brand__section-col-container">
					<div className="brand__section-col brand__section-col--small">
						<div className="l-flex">
							<div className="brand__logo-container brand__logo-container--glyph l-margin-right">
								<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/logo_glyph-primary@2x.png"} style={{maxWidth: '77px'}}/>
							</div>
							<div className="brand__logo-container brand__logo-container--glyph-round brand__logo-container--dark brand__logo-container--round">
								<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/logo_glyph-inverted@2x.png"} style={{maxWidth: '78px'}}/>
							</div>
						</div>
						<p className="l-margin-top text-color--lightGrey">Using the glyph alone is only acceptable in cases where space is extremely limited, like inside a circle or square.</p>
					</div>
				</div>
				<div className="l-margin-top text-color--lightGrey">
					<a href={"//" + blapp.config.getHost( "static2" ) + "/img/brand/BrickLink-logo-glyph.zip"} target="_blank"><i className="far fa-file-download l-margin-right--sm"/>Download glyphs</a> / ZIP file, 41kb
				</div>
			</section>
		);
	}

	renderDownloadAllLogos() {
		return (
			<section className="brand__section l-block">
				<div className="brand__section-col-container">
					<a href={"//" + blapp.config.getHost( "static2" ) + "/img/brand/BrickLink_logo-files.zip"} target="_blank" className="btn btn--cta text--white l-flex l-center text--left">
						<i className="fas fa-download text--title l-margin-right"/>
						<div>
							<strong className="l-block">Download all logos</strong>
							<small className="text--opaque">ZIP file, 5mb</small>
						</div>
					</a>
				</div>
			</section>
		);
	}

	renderSpacing() {
		return (
			<section className="brand__section brand__section--bordered">
				<div className="brand__section-col-container">
					<div className="brand__section-col">
						<h3 className="text--title text--bold l-margin-bottom--xl">Spacing</h3>
						<div className="brand__logo-container brand__logo-container--tight">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/logo-spacing@2x.png"} style={{maxWidth: '291px'}}/>
						</div>
						<p className="l-margin-top text-color--lightGrey l-margin-bottom">The minimum amount of clear space around the logo is equivalent to the center of the letter "b" in the wordmark.</p>
					</div>
					<div className="brand__section-col">
						<h3 className="text--title text--bold l-margin-bottom--xl">Minimum size</h3>
						<p className="l-margin-bottom text-color--lightGrey l-hide--desktop">To preserve legibility in all formats, see below for the minimum size.</p>
						<div className="brand__section-col-container">
							<div className="brand__section-col brand__section-col--small">
								<div className="brand__logo-container l-pad-null">
									<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/min-size_h@2x.png"} style={{maxWidth: '238px'}}/>
								</div>

								<div className="l-hide--desktop l-margin-top">
									<small className="l-block text--bold text-color--lightGrey text--uppercase">Print (Width)</small>
									<strong className="l-block">1.02 inches</strong>
									<strong className="l-block">2.60 centimeters</strong>
									<strong className="l-block">26.00 millimeters</strong>
								</div>
							</div>
							<div className="brand__section-col brand__section-col--small">
								<div className="brand__logo-container l-pad-null">
									<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/min-size_v@2x.png"} style={{maxWidth: '238px'}}/>
								</div>

								<div className="l-hide--desktop l-margin-top">
									<small className="l-block text--bold text-color--lightGrey text--uppercase">Digital (Height)</small>
									<strong>36px</strong>
								</div>
							</div>
						</div>
						<p className="l-margin-top text-color--lightGrey l-hide--small">To preserve legibility in all formats, see below for the minimum size.</p>
						<div className="brand__section-col-container l-margin-top l-hide--small">
							<div className="brand__section-col">
								<small className="l-block text--bold text-color--lightGrey text--uppercase">Print (Width)</small>
								<strong className="l-block">1.02 inches</strong>
								<strong className="l-block">2.60 centimeters</strong>
								<strong className="l-block">26.00 millimeters</strong>
							</div>
							<div className="brand__section-col">
								<small className="l-block text--bold text-color--lightGrey text--uppercase">Digital (Height)</small>
								<strong>36px</strong>
							</div>
						</div>
					</div>
				</div>
			</section>
		);
	}

	renderTreatments() {
		return (
			<section className="brand__section brand__section--bordered">
				<h3 className="text--title text--bold">Treatments to avoid</h3>
				<p className="text-color--lightGrey l-margin-bottom--xl">Below are examples of what to avoid when using our logo.</p>
				<div className="brand__section-col-container brand__section-col-container--tripple">
					<div className="brand__section-col">
						<div className="l-pad-null brand__logo-container">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/avoid-01@2x.png"} style={{maxWidth: '325px'}}/>
						</div>
						<p className="text--small l-margin-top l-margin-bottom text-color--lightGrey"><i className="far fa-times l-margin-right text-color--primaryRed"/>Do not add text to the logo</p>
					</div>
					<div className="brand__section-col">
						<div className="l-pad-null brand__logo-container">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/avoid-02@2x.png"} style={{maxWidth: '326px'}}/>
						</div>
						<p className="text--small l-margin-top l-margin-bottom text-color--lightGrey"><i className="far fa-times l-margin-right text-color--primaryRed"/>Do not stack the logo</p>
					</div>
					<div className="brand__section-col">
						<div className="l-pad-null brand__logo-container">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/avoid-03@2x.png"} style={{maxWidth: '325px'}}/>
						</div>
						<p className="text--small l-margin-top l-margin-bottom text-color--lightGrey"><i className="far fa-times l-margin-right text-color--primaryRed"/>Do not stretch the logo</p>
					</div>
				</div>
				<div className="brand__section-col-container brand__section-col-container--tripple">
					<div className="brand__section-col">
						<div className="l-pad-null brand__logo-container brand__logo-container--dark">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/avoid-04@2x.png"} style={{maxWidth: '325px'}}/>
						</div>
						<p className="text--small l-margin-top l-margin-bottom text-color--lightGrey"><i className="far fa-times l-margin-right text-color--primaryRed"/>Do not alter the logo's colors</p>
					</div>
					<div className="brand__section-col">
						<div className="l-pad-null brand__logo-container brand__logo-container--dark">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/avoid-05@2x.png"} style={{maxWidth: '326px'}}/>
						</div>
						<p className="text--small l-margin-top l-margin-bottom text-color--lightGrey"><i className="far fa-times l-margin-right text-color--primaryRed"/>Do not use where contrast is low</p>
					</div>
					<div className="brand__section-col">
						<div className="l-pad-null brand__logo-container brand__logo-container--dark">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/avoid-06@2x.png"} style={{maxWidth: '325px'}}/>
						</div>
						<p className="text--small l-margin-top l-margin-bottom text-color--lightGrey"><i className="far fa-times l-margin-right text-color--primaryRed"/>Do not rotate the logo</p>
					</div>
				</div>
			</section>
		);
	}

	renderTextAlts() {
		return (
			<section className="brand__section brand__section--bordered l-margin-top--xl">
				<h3 className="text--title text--bold">Text alternates</h3>
				<div className="brand__section-col-container">
					<div className="brand__section-col l-flex l-column">
						<p className="l-margin-bottom--xl">Use <strong>BrickLink</strong> when referring to the company. Capitalize the "B" and the "L".</p>

						<div className="l-margin-top--auto">
							<small className="l-block text--bold text-color--lightGrey text--uppercase">Examples</small>
							<div className="l-flex l-center"><i className="fa-fw far fa-check text-color--primaryGreen l-margin-right"/>BrickLink is the world's largest LEGO&reg; marketplace.</div>
							<div className="l-flex l-center"><i className="fa-fw far fa-check text-color--primaryGreen l-margin-right"/>The AFOL Designer Program is hosted by BrickLink.</div>
							<div className="l-flex l-center"><i className="fa-fw far fa-times text-color--primaryRed l-margin-right"/>Bricklink will be at the convention this year.</div>
						</div>
					</div>
					<div className="brand__section-col l-flex l-column">
						<p className="l-margin-bottom--xl">Treat <strong>bricklink.com</strong> as a place that people can go to. Lowercase all letters unless it's the first word in a sentence.</p>
					
						<div className="l-margin-top--auto">
							<small className="l-block text--bold text-color--lightGrey text--uppercase">Examples</small>
							<div className="l-flex l-center"><i className="fa-fw far fa-check text-color--primaryGreen l-margin-right"/>You can buy all the parts you need at <a className="l-margin-left--xs" href="//www.bricklink.com">bricklink.com</a>.</div>
							<div className="l-flex l-center"><i className="fa-fw far fa-check text-color--primaryGreen l-margin-right"/>Go to <a className="l-margin-x--xs" href="//www.bricklink.com">bricklink.com</a> to view all items in this theme.</div>
							<div className="l-flex l-center"><i className="fa-fw far fa-times text-color--primaryRed l-margin-right"/>I'm a seller on <a className="l-margin-left--xs" href="//www.bricklink.com">BrickLink.com</a>.</div>
						</div>
					</div>
				</div>
			</section>
		);
	}

	renderStoreBadges() {
		return (
			<section className="brand__section brand__section--bordered l-border--x-thick">
				<h3 className="text--title text--bold l-margin-bottom--xl">Store badges</h3>
				<div className="brand__section-col-container">
					<div className="brand__section-col">
						<div className="brand__logo-container">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/store-badge_main@2x.png"} style={{maxWidth: '176px'}}/>
						</div>
						<p className="l-margin-top text-color--lightGrey">If you are a seller on BrickLink, use this store badge to promote your store.</p>
						<div className="l-hide--desktop l-margin-top">
							<small className="l-block text--bold text-color--lightGrey text--uppercase">Embed badge</small>
							<textarea className="textarea textarea--stubby l-full-width brand__embed-code l-margin-bottom js-copy-content">{`<a href="https://store.bricklink.com/${this.state.storeName}"><img src="https://static2.bricklink.com/img/brand/store-badge_main@2x.png"/></a>`}</textarea>
							<button className="btn btn--link" onClick={(e) => this.copyCode(e, 1)}><i className="far fa-copy l-margin-right--sm"/>{this.state.copied == 1 ? 'Copied' : 'Copy code'}</button>
						</div>
					</div>
					<div className="brand__section-col">
						<div className="brand__logo-container">
							<img className="brand__logo-item" src={"//" + blapp.config.getHost( "static2" ) + "/img/brand/store-badge_alt@2x.png"} style={{maxWidth: '176px'}}/>
						</div>
						<p className="l-margin-top text-color--lightGrey">If the main badge does not complement its environment, use the alternate store badge.</p>
						<div className="l-hide--desktop l-margin-top">
							<small className="l-block text--bold text-color--lightGrey text--uppercase">Embed alternate badge</small>
							<textarea className="textarea textarea--stubby l-full-width brand__embed-code l-margin-bottom js-copy-content">{`<a href="https://store.bricklink.com/${this.state.storeName}"><img src="https://static2.bricklink.com/img/brand/store-badge_alt@2x.png"/></a>`}</textarea>
							<button className="btn btn--link" onClick={(e) => this.copyCode(e, 2)}><i className="far fa-copy l-margin-right--sm"/>{this.state.copied == 2 ? 'Copied' : 'Copy code'}</button>
						</div>
					</div>
				</div>
				<a href={"//" + blapp.config.getHost( "static2" ) + "/img/brand/bricklink_store-badges.zip"} target="_blank" className="btn btn--cta text--white l-inline-flex l-center text--left l-hide--small l-margin-bottom--xxl">
					<i className="fas fa-download text--title l-margin-right"/>
					<div>
						<strong className="l-block">Download badges</strong>
						<small className="text--opaque">ZIP file, 195kb</small>
					</div>
				</a>
				<div className="brand__section-col-container l-hide--small">
					<div className="brand__section-col">
						<small className="l-block text--bold text-color--lightGrey text--uppercase">Embed badge</small>
						<textarea className="textarea textarea--stubby l-full-width brand__embed-code l-margin-bottom js-copy-content">{`<a href="https://store.bricklink.com/${this.state.storeName}"><img src="https://static2.bricklink.com/img/brand/store-badge_main@2x.png"/></a>`}</textarea>
						<button className="btn btn--link" onClick={(e) => this.copyCode(e, 3)}><i className="far fa-copy l-margin-right--sm"/>{this.state.copied == 3 ? 'Copied' : 'Copy code'}</button>
					</div>
					<div className="brand__section-col">
						<small className="l-block text--bold text-color--lightGrey text--uppercase">Embed alternate badge</small>
						<textarea className="textarea textarea--stubby l-full-width brand__embed-code l-margin-bottom js-copy-content">{`<a href="https://store.bricklink.com/${this.state.storeName}"><img src="https://static2.bricklink.com/img/brand/store-badge_alt@2x.png"/></a>`}</textarea>
						<button className="btn btn--link" onClick={(e) => this.copyCode(e, 4)}><i className="far fa-copy l-margin-right--sm"/>{this.state.copied == 4 ? 'Copied' : 'Copy code'}</button>
					</div>
				</div>

				<a href={"//" + blapp.config.getHost( "static2" ) + "/img/brand/bricklink_store-badges.zip"} target="_blank" className="btn btn--cta text--white l-inline-flex l-center text--left l-hide--desktop l-margin-top--xl">
					<i className="fas fa-download text--title l-margin-right"/>
					<div>
						<strong className="l-block">Download badges</strong>
						<small className="text--opaque">ZIP file, 5mb</small>
					</div>
				</a>
			</section>
		);
	}

	copyCode(event, num) {
		const parent 	= event.target.parentNode;
		const content = parent.querySelector('.js-copy-content');
					content.select();
					content.setSelectionRange(0, 99999);

		document.execCommand("copy");

		this.setState({copied: num});

		setTimeout(() => {
			this.setState({copied: ''});
		}, 2000);
	}
};

document.addEventListener( "DOMContentLoaded", 
	function() {
		var	elem	=	ReactDOM.render(
							<Brand blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-brand' )
						);
		blapp.refs.register( "main", elem );
	}
);